import React from 'react';
import { Button } from '@c2fo/liquidity';
import { PlusIcon } from '@c2fo/liquidity/icons';

interface PageHeaderProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onActionClick?: () => void;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, description, actionLabel, onActionClick }) => {
  const hasAction = actionLabel && onActionClick;

  return (
    <div className={hasAction ? 'flex items-center justify-between mb-2' : 'mb-2'}>
      <div>
        <h1 className="text-2xl font-semibold text-foreground">{title}</h1>
        {description && <p className="text-sm text-muted-foreground mt-1">{description}</p>}
      </div>
      {hasAction && (
        <Button variant="primary" className="rounded-md text-white" onClick={onActionClick}>
          <span className="flex items-center gap-1">
            <PlusIcon fill="white" />
            {actionLabel}
          </span>
        </Button>
      )}
    </div>
  );
};
